module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-STACKOVERFLOW.4dccddfc.png";